var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardOrdersicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53,
    height: 52,
    viewBox: "0 0 33 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.332 9V11",
    stroke: "#DCFCE7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.332 21V23",
    stroke: "#DCFCE7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.332 28C22.9594 28 28.332 22.6274 28.332 16C28.332 9.37258 22.9594 4 16.332 4C9.70461 4 4.33203 9.37258 4.33203 16C4.33203 22.6274 9.70461 28 16.332 28Z",
    stroke: "#DCFCE7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.332 21H17.832C18.4951 21 19.131 20.7366 19.5998 20.2678C20.0686 19.7989 20.332 19.163 20.332 18.5C20.332 17.837 20.0686 17.2011 19.5998 16.7322C19.131 16.2634 18.4951 16 17.832 16H14.832C14.169 16 13.5331 15.7366 13.0643 15.2678C12.5954 14.7989 12.332 14.163 12.332 13.5C12.332 12.837 12.5954 12.2011 13.0643 11.7322C13.5331 11.2634 14.169 11 14.832 11H19.332",
    stroke: "#DCFCE7",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardOrdersicon);
export default __webpack_public_path__ + "static/media/dashboardOrders.icon.6b5ddd1654298ae619d907378bd236a2.svg";
export { ForwardRef as ReactComponent };